module.exports = __webpack_public_path__ + "static/media/filter.ad1e023a.svg";